module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/USB-f4f644185b923896f1271fa5343ac955.svg";